import { combineReducers } from "redux";
import authReducer from "./auth/authSlice";
import siteConfigurationReducer from "./site/configuration/siteConfigurationSlice";
import commonReducer from "./common/commonSlice";

const rootReducer = combineReducers({
  authReducer,
  siteConfigurationReducer,
  commonReducer,
});

export default rootReducer;
